import React, {useState} from 'react';
import {
    Card,
    CardText,
    CardActions,
    Button,
    Popup,
    Input,
    Divider,
    CardContent
} from '@chatui/core';
import CardTitleWithStatus from "../commonUtils/cardTitleWithStatus";


function ArtificialServiceTicket(props) {
    const title = props.title? props.title: "Artificial Service Ticket";
    const status = props.status? props.status: 0;
    const content = props.content? props.content: "A Artificial Service Ticket."
    const initAdditionalNotes = props.description ? props.description: "You could specify your questions here";
    const [open, setOpen] = useState(false);

    const [description, setDescription] = useState(initAdditionalNotes);
    const [hasSubmitted, setHasSubmitted] = useState(false);

    const onAcknowledge = () => {
        if (props.onAcknowledge && props.transferToHuman) {
            const table = [
                {name: "Type", type: 'text', value: "Other Intention"},
                {name: 'Description', type: 'text', value: description}
            ]
            props.onAcknowledge(title,content,table,props.language)
                .then((result)=>{
                    setHasSubmitted(true);
                    return props.transferToHuman();
                })
                .then(res=>{
                    console.log(res);
                })
                .catch(error=>{
                    console.log(error);
                })
        }
    }

    return (
        <Card fluid>
            <CardTitleWithStatus
                statusText={props.statusList[props.status]}
                title={title}
            ></CardTitleWithStatus>
            <CardContent>
                <CardText>{content}</CardText>
            </CardContent>

            {status===0?(
                <CardActions>
                    <Button disabled={hasSubmitted} onClick={()=>setOpen(true)}>Revise</Button>
                    <Popup
                    active={open}
                    title={"REVISE"}
                    onClose={() => {
                      setOpen(false);
                    }}
                    height={80}
                    >
                        <CardContent>
                            <p>Please tell us your needs</p>
                            <Input value={description} onChange={(val)=>setDescription(val)} rows={10}></Input>
                        </CardContent>
                    </Popup>
                    <Button disabled={hasSubmitted} color={'primary'} onClick={onAcknowledge}>Submit</Button>
                </CardActions>
            ):(
                <CardActions>
                    <Divider></Divider>
                    <Button>Go to check</Button>
                </CardActions>
            )}


        </Card>
    );
}

export default ArtificialServiceTicket;